import { type I18n, createI18n, useI18n } from "vue-i18n"

import en from "./en.json"
import ja from "./ja.json"
import ko from "./ko.json"
import zh from "./zh.json"

const LOCALE_KEY = "app.locale"

const messages: Record<string, typeof en> = { en, zh, ko, ja }
export const supportedLocales = Object.keys(messages)
export const localeLabels: Record<string, string> = { en: "English", zh: "中文", ko: "한국어", ja: "日本語" }

let _i18n: I18n | undefined

function detectLocale() {
  try {
    const saved = localStorage.getItem(LOCALE_KEY)
    if (saved && supportedLocales.includes(saved)) return saved
  } catch {}
  const nav = navigator.languages?.map((l) => String(l.split("-")[0])) ?? []
  const match = nav.find((l) => supportedLocales.includes(l))
  return match || navigator.language?.split("-")[0] || "en"
}

function setHtmlLang(lang: string) {
  if (typeof document !== "undefined") document.documentElement.lang = lang
}

export function setupI18n({ locale = detectLocale(), fallbackLocale = "en" } = {}) {
  _i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale,
    fallbackLocale,
    messages,
  })
  setHtmlLang(locale)
  return _i18n
}

export function setLocale(lang: string, i18n = _i18n) {
  if (!i18n || !supportedLocales.includes(lang)) return
  const loc = i18n.global.locale
  if (typeof loc === "object") loc.value = lang
  else i18n.global.locale = lang
  try {
    localStorage.setItem(LOCALE_KEY, lang)
  } catch {}
  setHtmlLang(lang)
}

export function getLocaleMessages() {
  const { locale } = useI18n()

  return messages[locale.value] || messages.en!
}
